import { ContinueReading } from '@/features/history';
import { Library } from '@/features/library';

/**
 * Saved page: resume first, then the unified cross-source favorites view.
 *
 * Implementation lives in `@/features/library` so the same component can
 * be used from the `/library` route (P6) and the existing
 * `/library/favorites` route without duplication. See
 * `src/features/library/README.md` for the dedup heuristic and refresh
 * policy.
 */
export function FavoritesPage() {
  return (
    <div className="flex flex-col gap-6">
      <ContinueReading limit={12} infinite />
      <Library title="Saved" description="Your favorites across every connected source." />
    </div>
  );
}
